/**
 * Variación frente al periodo anterior
 */

import { cn } from '@/lib/utils';
import { percentChange } from './format';

interface DeltaBadgeProps {
  current: number;
  previous: number;
  /** Texto tras la variación, p. ej. "vs. mes anterior" */
  label?: string;
  /** Solo la variación, como etiqueta de color (camino del comensal) */
  compact?: boolean;
}

function deltaText(change: number | null): string {
  if (change === null) return '—';
  const sign = change > 0 ? '+' : '';
  const arrow = change > 0 ? '↑' : change < 0 ? '↓' : '→';
  return `${arrow} ${sign}${change} %`;
}

export function DeltaBadge({ current, previous, label = 'vs. periodo anterior', compact = false }: DeltaBadgeProps) {
  const change = percentChange(current, previous);

  if (compact) {
    return (
      <span
        className={cn(
          'inline-flex items-center rounded-sm px-2 py-0.5 text-xs font-medium',
          change !== null && change > 0 && 'bg-green-50 text-green-800',
          change !== null && change < 0 && 'bg-red-50 text-red-800',
          (change === null || change === 0) && 'bg-gray-100 text-[#5f5d5b]'
        )}
        data-testid="delta"
      >
        {deltaText(change)}
      </span>
    );
  }

  if (change === null) {
    return (
      <p className="text-xs font-light text-[#9d9c9c]" data-testid="delta">
        — <span>{label}</span>
      </p>
    );
  }

  return (
    <p className="text-xs font-light text-[#9d9c9c]" data-testid="delta">
      <span
        className={cn(
          'font-medium',
          change > 0 && 'text-green-700',
          change < 0 && 'text-red-700',
          change === 0 && 'text-[#9d9c9c]'
        )}
      >
        {deltaText(change)}
      </span>{' '}
      {label}
    </p>
  );
}
